const proRoutes = [
  {
    list: '/product/tour/list/outbound',
    detail: '/product/tour/detail',
    order: '/order/tour',
    type: '73',
    channelPath: '/product/tour/list/outbound'
  },
  {
    list: '/product/tour/list',
    detail: '/product/tour/detail',
    type: '74',
    order: '/order/tour',
    channelPath: '/product/tour/list'
  },
  {
    list: '/product/tour/list/travel',
    detail: '/product/travel/detail',
    order: '/order/tour',
    type: '75',
    channelPath: '/product/tour/list/travel'
  },
  {
    list: '/product/tour/list/country',
    detail: '/product/tour/detail',
    order: '/order/tour',
    type: '76',
    channelPath: '/product/tour/list/country'
  },
  {
    list: '/product/tour/list/local',
    detail: '/product/tour/detail',
    order: '/order/tour',
    type: '77',
    channelPath: '/product/tour/list/local'
  },
  {
    list: '/product/tour/list/day',
    detail: '/product/tour/detail',
    order: '/order/tour',
    type: '81',
    channelPath: '/product/tour/list/day'
  },
  {
    list: '/product/tickets/list',
    detail: '/product/tickets/detail',
    order: '/order/tickets',
    type: '1',
    channelPath: '/product/tickets'
  },
  {
    list: '/product/hotel/list',
    detail: '/product/hotel/detail',
    order: '/order/hotel',
    type: '2',
    channelPath: '/product/hotel'
  },
  {
    list: '/product/visa/list',
    detail: '/product/visa/detail',
    order: '/order/visa',
    type: '3',
    channelPath: '/product/visa/list'
  },
  {
    list: '/product/scene/list',
    detail: '/product/scene/detail',
    order: '/order/scene',
    type: '4',
    channelPath: '/product/scene/list'
  },
  {
    list: '/product/commodity/list',
    detail: '/product/commodity/detail',
    order: '/order/commodity',
    type: '5',
    channelPath: '/product/commodity'
  },
  {
    list: '/product/presell/list',
    detail: '/product/presell/detail',
    type: '8',
    order: '/order/presell',
    channelPath: '/product/presell/list'
  },
  {
    list: '/product/customize',
    type: '80'
  },
  {
    list: '/product/plane',
    detail: '/product/plane/detail',
    order: '/order/plane/submit',
    type: '6',
    channelPath: '/product/plane'
  },
  {
    list: '/product/train',
    type: '7',
    channelPath: '/product/train'
  }
]

function getProTypeItem(type) {
  const typeStr = String(type)
  let findIndex = 0
  for (let i = 0, len = proRoutes.length; i < len; i++) {
    if (proRoutes[i].type === typeStr) {
      findIndex = i
      break
    }
  }
  return proRoutes[findIndex]
}

function addPathList(newList) {
  for (let i = 0, len = proRoutes.length; i < len; i++) {
    newList.push(proRoutes[i].list)
    newList.push(proRoutes[i].detail)
  }
}

function getDetailsPath(type) {
  return getProTypeItem(type).detail
}

function getProOrderPath(type) {
  return getProTypeItem(type).order
}

function getProListPath(type) {
  return getProTypeItem(type).list
}

function getChannelPath(type) {
  return getProTypeItem(type).channelPath
}

function getCachePathList() {
  const list = ['/']
  addPathList(list)
  return Array.from(new Set(list))
}

export default class AppRouteConfig {

  static getDetailsPath(type) {
    return getProTypeItem(type).detail
  }

  static getCouponSharePath() {
    return '/users/pocket/coupons/share'
  }

  static getRedPacketPath() {
    return '/users/operational/redPacket'
  }

  static getSalesTaskPath() {
    return '/users/operational/salesTask'
  }

  static getMemberCardBuyPath() {
    return '/users/pocket/memberCard/buy'
  }

  static getProductSpecialPath() {
    return '/product/special'
  }
}
